<template>

  <main class="content content--narrow">

    <div class="content__heading">
      <h1>
        <i class="logo--fusebox"></i> {{ type }} {{ $t('errors.error') }}
      </h1>
    </div>
    <div class="dashboard__grid__cell--boxed">
      {{ $t('errors.explanation') }}
    </div>

  </main>
</template>

<script>
export default {
  name: 'errors',
  props: {
    type: Number
  }
}
</script>
